export default {
  APP: 'admin',
};
